export enum COLORS {
  WHITE_DARK = '#f0f0f0',
  GREEN = '#99CC33',
  BLUE = '#6DB5E5',
  BLUE_LINK = '#2C78FF',
  RED = '#C3454C',
  RED_ERROR = '#FA1313',
  RED_HIGHLIGHT = '#FF3B30',
  AMBAR = '#D78D00',
  VIOLET = '#5A4B92',
  VIOLET_HIGHLIGHT = '#8971DE',
  GRAY_TEXT = '#888',
  BLACK = '#333',
  BLACK_BOLD = '#222',
  YELLOW = '#FFF2BF',
  YELLOW_DARK = '#B9A865',
  YELLOW_GENERIC = '#FFCC00',
  GRAY_PLACEHOLDER = '#BBB',
  GRAY_LIGHT = '#EEE',
  GRAY = '#DDD',
  GRAY_DARK = '#666',
  YELLOW_HIGHLIGHT = '#FFE212'
}
